import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import React, { ReactElement } from "react";
import { useTranslation } from 'react-i18next';
import { namespace } from '@common/config/constants';

export interface ConfirmationDialogProps {
    title: string;
    content: string;
    onCancel: () => void;
    onConfirm: () => void;
    open?: boolean;
}

export default function ConfirmationDialog(props: ConfirmationDialogProps): ReactElement {
    const { t } = useTranslation(namespace);

    return <Dialog
        open={props.open ?? false}
        onClose={props.onCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle>
            {props.title}
        </DialogTitle>
        <DialogContent>
            <DialogContentText>
                {props.content}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.onCancel} color="primary">
                {t('common.cancel')}
            </Button>
            <Button color="primary" autoFocus onClick={props.onConfirm}>
                {t('common.ok')}
            </Button>
        </DialogActions>
    </Dialog>
}
